import * as React from 'react';
import { Redirect, Route, useRouteMatch } from 'react-router-dom';
import routes from '../routes';
import styles from './styles/appStyles';
import { ComingSoon } from './ComingSoon';
import RunwayLogo from '../../assets/runway-wordmark.svg';
import { antGrey, runwayColors } from './styles/globalStyles';
import { LaptopOutlined } from '@ant-design/icons';
import Button from 'antd/lib/button';
import { useDispatch, useSelector } from 'react-redux';
import { tryLogout, TRY_LOGOUT } from '../actions/login';
import { globalMessage } from '../utils/globalMessage';
import { selectUserIsLoggedIn } from '../selectors/selectors';
import { RootState } from '../reducers/reducers';
import { useError, useIsLoading } from '@/utils/hooks/helpers';

const MobileLandingComponent = () => {
    const match = useRouteMatch(routes.mobile);

    if (!match) {
        console.debug(
            '[REDIRECT DEBUG]',
            'current route:',
            window.location.pathname,
            '-> next route:',
            routes.mobile,
            '(no mobile route match)',
        );
        return <Redirect to={routes.mobile} />;
    }

    const isLoggedIn = useSelector((state: RootState) => selectUserIsLoggedIn(state));

    const logoutIsLoading = useIsLoading(TRY_LOGOUT);
    const logoutError = useError(TRY_LOGOUT);

    const dispatch = useDispatch();

    const logout = () => {
        dispatch(tryLogout());
    };

    React.useEffect(() => {
        if (logoutError) {
            globalMessage.error(logoutError);
        }
    }, [logoutError]);

    if (!isLoggedIn) {
        console.debug(
            '[REDIRECT DEBUG]',
            'current route:',
            routes.mobile,
            '-> next route:',
            routes.login,
            '(not logged in on mobile landing)',
        );
        return <Redirect to={routes.login} />;
    }

    return (
        <Route path={routes.mobile}>
            <div
                style={{
                    ...styles.appContainer,
                    backgroundColor: runwayColors.lightBackgroundGrey,
                    flexDirection: 'column',
                    padding: 24,
                }}
            >
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <img src={RunwayLogo} alt="Runway" />
                </div>
                <div style={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <ComingSoon
                        title="Not optimized for mobile"
                        description="Parts of the Runway platform are not optimized for mobile. To add a new app or view releases, please visit Runway on your desktop browser."
                        icon={<LaptopOutlined style={{ color: antGrey.grey5 }} />}
                    />
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Button onClick={logout} loading={logoutIsLoading}>
                        Sign out
                    </Button>
                </div>
            </div>
        </Route>
    );
};

export default MobileLandingComponent;
